import {
  driverIOCardCarList,
  driverIOCardAddData,
  driverIOCardUpdateData,
  driverIOCardDeleteData
} from '@/api/api'

const state = {
  driverIOCardList: [],
  driverIOCardTotal: 0
}

const getters = {
  driverIOCardList: state => state.driverIOCardList,
  driverIOCardTotal: state => state.driverIOCardTotal
}

const actions = {
  loadDriverIOCardList ({ dispatch }, parm) {
    return driverIOCardCarList(parm).then((data) => {
      dispatch('setDriverIOCardList', data.list)
      dispatch('setDriverIOCardTotal', data.total)
    })
  },
  addDriverIOCard ({ commit }, parm) {
    return driverIOCardAddData(parm)
  },
  updateDriverIOCard ({ commit }, parm) {
    return driverIOCardUpdateData(parm)
  },
  delDriverIOCard ({ commit }, gasId) {
    return driverIOCardDeleteData(gasId)
  },
  setDriverIOCardList ({ commit }, data) {
    commit('setDriverIOCardList', data)
  },
  setDriverIOCardTotal ({ commit }, data) {
    commit('setDriverIOCardTotal', data)
  }
}

const mutations = {
  setDriverIOCardList (state, data) {
    state.driverIOCardList = data
  },
  setDriverIOCardTotal (state, data) {
    state.driverIOCardTotal = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base_data/driver_io_card.js